<template>
  <div class="h-full / flex flex-col gap-2 items-center justify-center / bg-gray-900 text-white text-lg cursor-default">
    <FontAwesomeIcon icon="heading" />
    <div class="whitespace-normal text-center min-w-0 inline-block w-full px-4 text-xs">
      <p class="truncate mb-0">Section Header</p>
    </div>
  </div>
</template>
